"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var Badge = function (props) { return (React.createElement(Badge.Element, __assign({}, automation_attribute_1.default('badge'), props), props.children)); };
Badge.Element = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 13px;\n  font-weight: ", ";\n  line-height: 1;\n  color: #fff;\n  padding: 4px 8px;\n  background: ", ";\n  border-radius: 21px;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 13px;\n  font-weight: ", ";\n  line-height: 1;\n  color: #fff;\n  padding: 4px 8px;\n  background: ", ";\n  border-radius: 21px;\n"])), tokens_1.fonts.weight.medium, function (props) { return tokens_1.colors.status[props.appearance]; });
var StyledBadge = Badge.Element;
exports.StyledBadge = StyledBadge;
Badge.defaultProps = {
    appearance: 'default'
};
exports.default = Badge;
var templateObject_1;
//# sourceMappingURL=badge.js.map